function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */

/* template */
var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "timeline__container"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-4a38fda0_0", {
    source: ".timeline__container .timeline__item:first-child .timeline__content[data-v-4a38fda0]::before{height:calc(100% - 35px + 20px);top:35px}.timeline__container .timeline__item:last-child .timeline__content[data-v-4a38fda0]::before{height:35px}@media screen and (max-width:411px){.timeline__container[data-v-4a38fda0]{margin-right:37%}}@media screen and (max-width:375px){.timeline__container[data-v-4a38fda0]{width:60%}}@media screen and (max-width:360px){.timeline__container[data-v-4a38fda0]{width:58%}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-4a38fda0";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, {}, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: "TimeLineItem",
  props: {
    icon: {
      type: String,
      default: () => null
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "d-flex timeline__item"
  }, [_c('div', {
    staticClass: "mr-3 mt-4"
  }, [_c('div', {
    staticClass: "w-date-fixed"
  }, [_vm._t("date")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "timeline__content w-100"
  }, [_c('div', {
    staticClass: "timeline__content--inner p-4"
  }, [_vm.icon || _vm.$slots['icon'] ? _c('div', {
    staticClass: "icon-absolute"
  }, [_vm.$slots['icon'] ? _vm._t("icon") : _c('em', {
    staticClass: "radius text-white",
    class: _vm.icon
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-4675a68a_0", {
    source: ".timeline__content[data-v-4675a68a]{margin-bottom:20px;margin-left:40px;position:relative}.timeline__content .timeline__content--inner[data-v-4675a68a]{background:#f7f7f7;border-radius:3px;position:relative}.icon-absolute[data-v-4675a68a]{position:absolute;left:-1.3%}.radius[data-v-4675a68a]{padding:8px;padding-top:9px;width:36px;height:36px;text-align:center;background-color:#b5c3bc;border-radius:50%}.timeline__content[data-v-4675a68a]:before{background:#e2e2e2;border-radius:2px;box-shadow:0 0 3px rgba(0,0,0,.2);content:\"\";height:calc(100% + 20px);left:-30px;position:absolute;width:1px}.timeline__content[data-v-4675a68a]:after{background:#707070;border:2px solid #707070;border-radius:50%;box-shadow:0 0 5px rgba(0,0,0,.1);content:\"\";height:10px;left:-34px;position:absolute;top:35px;width:10px}.w-date-fixed[data-v-4675a68a]{width:90px}@media screen and (max-width:1055px){.icon-absolute[data-v-4675a68a]{left:-2%}}@media screen and (max-width:780px){.icon-absolute[data-v-4675a68a]{left:-3%}}@media screen and (max-width:670px){.icon-absolute[data-v-4675a68a]{left:-3.3%}}@media screen and (max-width:411px){.icon-absolute[data-v-4675a68a]{left:-6%!important}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-4675a68a";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

// Import vue component

const install = function installTimeline(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('Timeline', __vue_component__);
};

const installTimeLineItem = function installTimeline(Vue) {
  if (installTimeLineItem.installed) return;
  installTimeLineItem.installed = true;
  Vue.component('TimelineItem', __vue_component__$1);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install;
__vue_component__$1.install = installTimeLineItem; // Export component by default

const TimeLine = __vue_component__;
const TimeLineItem = __vue_component__$1;

export { TimeLine, TimeLineItem };
